export const categories = [
  { id: 'drama', name: '剧情大片', slug: 'drama', icon: 'ri-movie-2-line', description: '精彩原创剧情系列，引人入胜的故事体验' },
  { id: 'comedy', name: '喜剧综艺', slug: 'comedy', icon: 'ri-emotion-laugh-line', description: '欢乐搞笑内容合集，轻松一刻尽在这里' },
  { id: 'documentary', name: '纪录纪实', slug: 'documentary', icon: 'ri-camera-lens-line', description: '真实记录生活百态，深度探索世界精彩' },
  { id: 'music', name: '音乐现场', slug: 'music', icon: 'ri-music-2-line', description: '原创音乐MV与现场演出，感受音乐魅力' },
  { id: 'lifestyle', name: '生活时尚', slug: 'lifestyle', icon: 'ri-heart-line', description: '品质生活指南，时尚潮流的灵感源泉' },
  { id: 'tech', name: '科技数码', slug: 'tech', icon: 'ri-smartphone-line', description: '前沿科技资讯，数码产品深度评测' },
];

export const articleList = [
  {
    id: 1,
    slug: '2024-nian-du-jing-xuan-ju-qing-da-pian',
    title: '2024年度精选剧情大片合集：不可错过的精彩故事',
    excerpt: '盘点了麻豆视频2024年度最受欢迎的剧情类原创内容，从悬疑推理到温情治愈，每一部都值得细细品味。',
    category: 'drama',
    author: '麻豆编辑部',
    publishDate: '2026-08-10',
    readTime: '8分钟',
    imageSeq: 'article-cover-01',
    imageQuery: 'Cinematic film scene with dramatic lighting and warm tones, movie set atmosphere with vintage camera equipment, soft bokeh background, editorial photography style, rich colors and deep shadows, artistic composition',
    views: 12580,
    tags: ['精选合集', '剧情', '年度推荐', '原创'],
    content: `
      <p>在过去的2024年里，麻豆视频平台涌现了大量优质的原创剧情内容。从扣人心弦的悬疑推理到温暖治愈的都市情感，创作者们用镜头讲述了一个个动人的故事。</p>
      
      <h2>悬疑推理：烧脑剧情等你来解</h2>
      <p>悬疑推理类作品一直是麻豆视频最受欢迎的类型之一。2024年，多部高质量的悬疑作品在平台上线，以其精妙的剧情设计和出色的表演赢得了观众的广泛好评。《暗夜追踪》系列以其紧凑的节奏和层层递进的悬念设置，成为年度播放量最高的悬疑作品。</p>
      
      <h2>都市情感：细腻描绘现代生活</h2>
      <p>都市情感剧以真实细腻的情感刻画见长。这类作品聚焦当代都市人的情感世界，探讨爱情、友情、亲情等永恒主题。《城市之光》用温暖治愈的叙事方式，讲述了三个年轻人在大城市打拼的故事，引发广泛共鸣。</p>
      
      <h2>历史古装：穿越时空的视觉盛宴</h2>
      <p>历史古装类作品在2024年同样表现出色。精良的制作、考究的服饰道具，以及富有文化底蕴的故事情节，让这些作品成为平台上的"流量担当"。《长安风华》以盛唐为背景，展现了一段跨越阶级的爱情故事。</p>
      
      <h2>科幻奇幻：打开想象的无限可能</h2>
      <p>科幻奇幻类作品展现了创作者丰富的想象力。从未来世界到平行宇宙，这些作品带领观众踏上一段段奇妙的旅程。低成本但高创意的制作方式，证明了好的故事才是内容的核心。</p>
    `,
  },
  {
    id: 2,
    slug: 'gao-qing-yuan-chuang-nei-rong-zhi-zuo-bei-hou',
    title: '高清原创内容制作幕后：揭秘麻豆视频的品质之路',
    excerpt: '深入了解麻豆视频高清原创内容的制作流程，从前期策划到后期制作，每一个环节都精益求精。',
    category: 'tech',
    author: '麻豆技术团队',
    publishDate: '2026-08-08',
    readTime: '6分钟',
    imageSeq: 'article-cover-02',
    imageQuery: 'Professional video production studio interior with modern equipment, cameras and lighting rigs, warm ambient lighting, clean organized workspace, cinematic production atmosphere, high-end professional photography',
    views: 8920,
    tags: ['制作幕后', '技术', '高清', '原创'],
    content: `
      <p>在麻豆视频，每一部高清原创内容的诞生都凝聚着众多创作者的心血。从最初的一个创意火花，到最终呈现在观众面前的精彩画面，这其中经历了无数环节的精雕细琢。</p>
      
      <h2>前期策划：好故事从构思开始</h2>
      <p>每一个优秀的内容作品都源自一个好的创意。麻豆视频的内容策划团队会从社会热点、用户需求和创作趋势出发，与创作者共同打磨每一个故事。策划阶段包括选题调研、剧本创作、分镜头设计等多个环节。</p>
      
      <h2>拍摄制作：4K超高清的视觉标准</h2>
      <p>麻豆视频坚持采用4K超高清标准进行拍摄。平台为创作者配备了专业级的拍摄设备，包括电影级摄影机、专业灯光系统和高品质收音设备。每一帧画面都经过精心构图和光线设计。</p>
      
      <h2>后期处理：精益求精的细节打磨</h2>
      <p>后期制作是决定最终品质的关键环节。麻豆视频的后期团队运用专业的调色技术，确保画面色彩的真实还原和艺术表达。音效设计同样不容忽视，从环境音到背景音乐，每一个声音元素都经过精心挑选和混音处理。</p>
      
      <h2>品质把控：多重审核确保内容质量</h2>
      <p>在上线之前，每一部作品都需要经过严格的内容审核和技术质检。内容审核确保作品符合平台规范和社会价值观，技术质检则保证画面清晰度、音频质量等技术指标达到高清标准。</p>
    `,
  },
  {
    id: 3,
    slug: 'ma-dou-shi-pin-hui-yuan-fu-wu-quan-mian-jie-xi',
    title: '麻豆视频会员服务全面解析：解锁更多精彩内容',
    excerpt: '详细介绍麻豆视频会员的各项权益和服务内容，帮助用户选择最适合自己的会员方案。',
    category: 'lifestyle',
    author: '麻豆客服中心',
    publishDate: '2026-08-06',
    readTime: '5分钟',
    imageSeq: 'article-cover-03',
    imageQuery: 'Premium lifestyle scene with golden warm tones, elegant interior setting with comfortable sofa and tablet device, cozy atmosphere with soft lighting, modern minimal design, luxurious yet accessible feeling',
    views: 15630,
    tags: ['会员服务', '使用指南', '权益', '订阅'],
    content: `
      <p>麻豆视频为不同需求的用户提供了灵活的会员服务方案。无论您是偶尔观看的轻度用户，还是深度沉浸的重度粉丝，都能找到适合自己的会员方案。</p>
      
      <h2>会员核心权益一览</h2>
      <p>成为麻豆视频会员后，您将享受以下核心权益：超高清4K画质观看、无广告纯净体验、独家原创内容抢先看、会员专属内容库访问、多设备同时登录、离线下载功能等。</p>
      
      <h2>会员方案对比</h2>
      <p>麻豆视频目前提供三种会员方案：月度会员适合短期使用需求，季度会员具有更高的性价比，年度会员则是长期用户的最佳选择，平均每月费用最低。所有方案均支持自动续费管理，用户可以随时取消。</p>
      
      <h2>如何开通会员</h2>
      <p>开通麻豆视频会员非常简单。您可以通过官方网站或App内的会员中心页面，选择心仪的会员方案，完成支付后即可立即享受会员权益。支持多种支付方式，包括微信支付、支付宝和银行卡支付。</p>
      
      <h2>常见问题解答</h2>
      <p>会员到期后未续费，已下载的内容是否可以继续观看？答案是可以的，已下载到本地的内容在会员有效期内下载的，可以在下载后的7天内离线观看。会员权益是否可以与家人共享？目前支持在最多3台设备上同时登录使用。</p>
    `,
  },
  {
    id: 4,
    slug: 'shou-ji-pai-she-ji-qiao-ru-men-zhi-nan',
    title: '手机拍摄技巧入门指南：用手机也能拍出大片质感',
    excerpt: '无需昂贵设备，掌握这些手机拍摄技巧，每个人都能成为优秀的内容创作者。',
    category: 'tech',
    author: '麻豆创作学院',
    publishDate: '2026-08-04',
    readTime: '7分钟',
    imageSeq: 'article-cover-04',
    imageQuery: 'Person holding smartphone filming outdoor scene with beautiful natural lighting, golden hour photography, urban background with warm sunset tones, creative mobile filmmaking, casual lifestyle photography',
    views: 20150,
    tags: ['拍摄技巧', '手机摄影', '创作教程', '入门'],
    content: `
      <p>随着智能手机摄像头技术的飞速发展，用手机拍摄高质量视频已经不再是梦想。本指南将为您介绍一系列实用的手机拍摄技巧，帮助您用最便携的设备创作出令人惊艳的视觉内容。</p>
      
      <h2>基础设置：拍好视频的第一步</h2>
      <p>在开始拍摄之前，确保您的手机设置正确至关重要。建议将视频分辨率设置为最高可用选项（通常是4K），帧率选择30fps或60fps。同时，打开网格线辅助构图，锁定曝光和对焦，避免拍摄过程中画面忽明忽暗。</p>
      
      <h2>光线运用：好光出好片</h2>
      <p>光线是摄影和摄像的灵魂。尽量利用自然光拍摄，黄金时段（日出后和日落前的一小时）的光线最为柔和美丽。避免在正午强光下拍摄，如果必须在室内拍摄，尽量靠近窗户利用自然光，或使用柔和的补光灯。</p>
      
      <h2>构图技巧：让画面更有故事感</h2>
      <p>好的构图能让普通的画面变得不平凡。运用三分法则将主体放在画面的黄金分割点上；利用前景元素增加画面层次感；注意背景的简洁性，避免杂乱元素分散观众注意力。拍摄人物时，留出适当的"视线空间"。</p>
      
      <h2>稳定拍摄：告别画面抖动</h2>
      <p>画面稳定是专业感和业余感的分水岭。使用双手持机，将手肘紧贴身体，形成稳定的"人体三脚架"。移动拍摄时，采用"忍者步"——膝盖微曲，小步移动。如果预算允许，投资一个手机稳定器将大大提升拍摄质量。</p>
    `,
  },
  {
    id: 5,
    slug: 'yuan-chuang-yin-le-ren-xin-xiu-zhuan-chang',
    title: '原创音乐人新秀专场：发现下一个音乐之星',
    excerpt: '麻豆视频音乐频道全新企划，聚焦新兴原创音乐人，为你带来最纯粹的音乐体验。',
    category: 'music',
    author: '麻豆音乐频道',
    publishDate: '2026-08-02',
    readTime: '5分钟',
    imageSeq: 'article-cover-05',
    imageQuery: 'Intimate live music performance scene with warm stage lighting, acoustic guitar player on small stage, atmospheric venue with soft amber spotlights, indie music concert photography, artistic moody atmosphere',
    views: 9870,
    tags: ['原创音乐', '新秀', '音乐现场', '独立音乐'],
    content: `
      <p>麻豆视频音乐频道重磅推出"原创音乐人新秀专场"企划，致力于发掘和推广优秀的独立音乐人和原创音乐作品。本期我们精选了五位值得关注的新锐音乐人，他们用独特的音乐语言讲述着自己的故事。</p>
      
      <h2>城市民谣：用歌声记录生活</h2>
      <p>民谣作为一种最贴近生活的音乐形式，在年轻音乐人中拥有广泛的创作基础。来自成都的音乐人小林，用一把吉他和真挚的歌词，记录着城市生活的点点滴滴。他的作品《深夜的便利店》在平台上线后迅速获得10万+播放量。</p>
      
      <h2>电子音乐：探索声音的边界</h2>
      <p>电子音乐制作人阿哲将传统中国乐器采样与现代电子节拍融合，创造出独特的"东方电子"风格。他的音乐既有国际化的制作水准，又保留了浓厚的东方韵味，展现了新一代音乐人的创新精神。</p>
      
      <h2>嘻哈说唱：年轻一代的声音</h2>
      <p>嘻哈音乐在年轻群体中的影响力与日俱增。麻豆视频平台上的说唱新人们用犀利的歌词和独特的flow，表达着对生活、梦想和社会的思考。他们的作品不仅是音乐，更是一代年轻人的态度宣言。</p>
    `,
  },
  {
    id: 6,
    slug: 'mei-shi-tan-dian-ji-shi-cheng-shi-wei-lei-tu-jian',
    title: '美食探店纪实：城市味蕾图鉴之街头小吃篇',
    excerpt: '跟随麻豆视频美食频道的镜头，走遍城市的大街小巷，探寻那些藏在街角的美味秘境。',
    category: 'lifestyle',
    author: '麻豆美食频道',
    publishDate: '2026-07-30',
    readTime: '6分钟',
    imageSeq: 'article-cover-06',
    imageQuery: 'Street food scene in Asian night market with steam rising from food stalls, warm tungsten lighting, colorful food displays, bustling atmosphere, food photography with shallow depth of field, authentic cultural experience',
    views: 18340,
    tags: ['美食探店', '街头小吃', '城市攻略', '生活方式'],
    content: `
      <p>每一座城市都有它独特的味道。麻豆视频美食频道的探店团队走遍了城市的大街小巷，用镜头记录下那些藏在街角的美味秘境。本期我们聚焦街头小吃，带你领略城市最地道的味蕾体验。</p>
      
      <h2>老城区里的百年味道</h2>
      <p>在城市的旧城区，隐藏着许多经营了几十年的老店。这些店铺可能没有精致的装修，但每一道菜品都承载着几代人的记忆和匠心。从手工拉面到传统糕点，每一口都是时间的味道。</p>
      
      <h2>新兴夜市的创意小吃</h2>
      <p>近年来，各地的夜市文化蓬勃发展。年轻摊主们将传统小吃与现代创意相结合，打造出一系列既有颜值又美味的创新小吃。芝士焗红薯、抹茶鸡蛋仔、泰式卷饼……这些创意美食正在成为城市夜生活的新宠。</p>
      
      <h2>街角咖啡店的慢时光</h2>
      <p>除了传统小吃，城市中越来越多的小众咖啡店也成为了美食探店的热门目的地。这些咖啡店往往藏在不起眼的小巷中，却有着独特的空间设计和精心调制的饮品，是城市人放松身心的好去处。</p>
    `,
  },
  {
    id: 7,
    slug: 'ke-ji-shu-ma-xin-pin-shen-du-ping-ce',
    title: '科技数码新品深度评测：2026年最值得入手的智能设备',
    excerpt: '麻豆科技频道为您带来2026年度最新智能设备的深度评测，从实际体验出发，给出最中肯的购买建议。',
    category: 'tech',
    author: '麻豆科技频道',
    publishDate: '2026-07-28',
    readTime: '9分钟',
    imageSeq: 'article-cover-07',
    imageQuery: 'Modern tech gadgets arranged on clean minimalist desk, smartphone smartwatch wireless earbuds, natural light from window, product photography with neutral background, sleek contemporary design aesthetic',
    views: 22300,
    tags: ['科技评测', '数码产品', '智能设备', '新品'],
    content: `
      <p>2026年已经过半，各大科技厂商纷纷推出了自家的旗舰产品。麻豆科技频道对市场上最受关注的几款智能设备进行了深度评测，从实际使用体验出发，为您提供最客观的购买参考。</p>
      
      <h2>旗舰手机横评：影像能力成主战场</h2>
      <p>今年的旗舰手机在影像系统上的竞争尤为激烈。一英寸大底传感器、可变光圈、AI计算摄影……各大品牌纷纷亮出看家本领。经过实际拍摄对比测试，我们发现不同品牌的调校风格差异明显，用户应根据自己的拍摄偏好进行选择。</p>
      
      <h2>真无线耳机：降噪与音质的平衡之道</h2>
      <p>真无线降噪耳机市场竞争白热化。今年的新品在降噪深度和音质表现上都有明显提升。其中自适应降噪功能的普及让用户体验更上一层楼——耳机可以根据环境噪音自动调整降噪等级，兼顾了降噪效果和佩戴舒适度。</p>
      
      <h2>智能手表：健康监测再升级</h2>
      <p>智能手表已从简单的通知显示设备，升级为全方位的健康管理工具。今年的新品普遍加入了血压监测、血糖趋势分析等进阶健康功能。虽然这些功能还不能完全替代专业医疗设备，但作为日常健康参考已经相当实用。</p>
    `,
  },
  {
    id: 8,
    slug: 'ji-lu-pian-bei-wang-de-shou-yi-ren',
    title: '纪录片《被忘的手艺人》：致敬即将消失的传统技艺',
    excerpt: '麻豆视频原创纪录片系列最新力作，深入探访那些坚守传统手艺的匠人们，记录他们的故事与坚守。',
    category: 'documentary',
    author: '麻豆纪录片团队',
    publishDate: '2026-07-25',
    readTime: '7分钟',
    imageSeq: 'article-cover-08',
    imageQuery: 'Elderly artisan working with traditional craft tools in rustic workshop, warm natural light through window, wooden textures and hand tools, documentary photography style, authentic cultural heritage atmosphere',
    views: 7650,
    tags: ['纪录片', '传统手艺', '文化传承', '原创'],
    content: `
      <p>在这个飞速发展的时代，许多传统手艺正在悄然消失。麻豆视频原创纪录片团队历时三个月，走访了五个省份的十余位传统手艺人，用镜头记录下他们的故事与坚守。</p>
      
      <h2>铁匠铺的最后传承人</h2>
      <p>在浙江的一个小镇上，65岁的王师傅是当地最后一位传统铁匠。他的铁匠铺已经经营了超过40年，如今面临着无人继承的困境。"现在的年轻人不愿意学这个了，太苦太累。"王师傅说。但他依然每天清晨点燃炉火，用一锤一锤的敲打声唤醒了小镇的清晨。</p>
      
      <h2>竹编匠人的指尖艺术</h2>
      <p>在四川的山区，竹编技艺代代相传。70岁的李奶奶从12岁开始学习竹编，如今已经编了快60年。她的作品从日常的篮子、席子到精美的艺术品，每一件都倾注了她对这门手艺的热爱。"竹子是有生命的，你要用心去感受它。"李奶奶的这句话让我们深受触动。</p>
      
      <h2>守护与传承：年轻的希望</h2>
      <p>令人欣慰的是，一些年轻人开始重新关注传统手艺。通过短视频平台，越来越多的年轻人了解并爱上了这些传统技艺。一些手艺人开始尝试用新的方式传播和教授传统手艺，让这些珍贵的文化遗产在数字时代焕发新生。</p>
    `,
  },
];

export const faqList = [
  {
    question: '麻豆视频是否免费？',
    answer: '麻豆视频提供免费和会员两种服务模式。免费用户可观看标清内容并包含贴片广告；会员用户享受4K超高清画质、去广告纯净体验、独家原创内容抢先看、离线下载等专属权益。',
  },
  {
    question: '如何下载麻豆视频高清内容离线观看？',
    answer: '麻豆视频会员用户可在App内直接下载支持的内容到本地设备。下载路径：打开您想下载的视频 → 点击视频播放器下方的"下载"按钮 → 选择清晰度 → 开始下载。下载后可在"我的 → 离线缓存"中查看和管理已下载内容。',
  },
  {
    question: '麻豆视频支持哪些设备观看？',
    answer: '麻豆视频支持多种设备观看，包括：iOS/Android手机和平板（通过官方App）、Windows/Mac电脑（通过Web浏览器）、智能电视（通过TV版App）、平板电脑等。一个会员账号最多支持3台设备同时在线观看。',
  },
  {
    question: '麻豆视频的内容多久更新一次？',
    answer: '麻豆视频坚持每日更新，新内容发布时间集中在每日18:00-20:00。原创内容保持每周至少3-5部新作的更新频率。热门系列作品按季更新，确保内容的持续新鲜度。您可以在"最新上线"栏目中查看最近更新的内容。',
  },
  {
    question: '如何成为麻豆视频的创作者？',
    answer: '您可以访问麻豆视频官网的创作者入驻页面提交申请。需要提供个人或团队的基本信息、代表作品和创作方向。审核周期一般为3-5个工作日。通过审核后即可在创作者后台发布内容，并享受平台提供的流量扶持和创作激励计划。',
  },
  {
    question: '会员自动续费如何取消？',
    answer: '取消自动续费的操作路径：进入麻豆视频App → "我的" → "会员中心" → "管理自动续费" → 选择"关闭自动续费"。取消后当前会员周期不受影响，到期后将不再自动扣费。您也可以随时重新开启自动续费。',
  },
];

export const homeStats = [
  { value: '5000+', label: '原创内容' },
  { value: '200万+', label: '日活跃用户' },
  { value: '10万+', label: '入驻创作者' },
  { value: '99.7%', label: '用户满意度' },
];

export const homeFeatures = [
  {
    icon: 'ri-4k-line',
    title: '4K超高清画质',
    description: '采用先进的视频编码技术，会员专享4K超高清视觉体验，每一帧都清晰细腻，让您身临其境感受内容魅力。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '原创正版保障',
    description: '平台所有内容均获得正版授权或为原创出品，严格的内容审核机制确保视频质量和版权合规，让您放心观看。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝切换',
    description: '支持手机、平板、电脑、智能电视等多终端观看，观影记录和收藏自动云端同步，随时随地继续您的观影之旅。',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '离线下载畅享',
    description: '会员用户支持高清内容离线下载，无需网络也能畅快观看，地铁通勤、长途旅行的最佳伴侣。',
  },
];

export const testimonials = [
  {
    name: '李同学',
    role: '大学生用户',
    content: '麻豆视频的画质真的没话说，4K看着特别舒服。而且原创内容质量很高，比那些千篇一律的短视频平台有意思多了。',
  },
  {
    name: '王女士',
    role: '职场白领',
    content: '每天下班后最期待的就是打开麻豆视频看最新的原创剧集。内容质量高，更新稳定，会员价格也很合理。',
  },
  {
    name: '张先生',
    role: '自由创作者',
    content: '作为创作者，麻豆视频给了我很好的展示平台。流量扶持和创作激励都很到位，让我能专心做自己喜欢的内容。',
  },
];